import type { RootState } from 'reactApp/store';
import type { LoadingState } from 'reactApp/types/commonStates';
import { createSelector } from 'reselect';

import { type UserSocialBind, type UserSocialBindsState, UserSocialBindType } from './userSocialBinds.types';

export const getUserSocialBindsRoot = (state: RootState) => state.useSocialBinds;

const getLoadingState = createSelector(
    getUserSocialBindsRoot,
    (state: UserSocialBindsState): LoadingState => ({
        isLoading: state.isLoading,
        isLoaded: state.isLoaded,
    })
);

const getVkId = createSelector(getUserSocialBindsRoot, (state: UserSocialBindsState): UserSocialBind | undefined => {
    return state.accounts.find(({ type }) => type === UserSocialBindType.vkid);
});

export const UserSocialBindSelectors = {
    getLoadingState,
    getVkId,
};
